import React, { useState } from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import GenericFlatButton from '../../GenericFlatButton'

import { styles } from './styles'

const ApproveModal = ({ requestData, onApprove, classes }) => {
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const onSubmit = async () => {
    setIsLoading(true)

    await onApprove(requestData)
    dispatch(hideReduxModal())

    setIsLoading(false)
  }

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalTitle}>
        Do you want approve {requestData.name} for BA?
      </div>
      <div className={classes.description}>Action cannot be undone</div>
      <div className={classes.modalButtonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => {
            dispatch(hideReduxModal())
          }}
          disabled={isLoading}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Approve'}
          loading={isLoading}
          disabled={isLoading}
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(ApproveModal)
